export default "__VITE_PUBLIC_ASSET__582aaa62__"